<template>
  <v-container grid-list-xl class="pa-5">
    <v-alert
      v-if="is_premium"
      dense text
      class="body-2 mb-5"
      type="info"
    >
      Berikut ini merupakan data periode yang dapat Anda gunakan untuk
      melakukan <b>cetak rekap kehadiran </b>
      berdasarkan periode yang telah Anda buat. Klik tambah (+) untuk
      membuat data Periode baru.
    </v-alert>
    <m-card-list
      two-line
      title="Periode"
      label-cari="Cari Periode"
      :add="isCan(`periode-laporan.${keyAkses}store`)"
      edit
      search
      :items="items"
      :headers="headers"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="
            search => {
              textSearch = search;
              load();
            }
          "
      @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
      @add="add"
    >
      <template v-slot:items="{ props, item }">
        <tr v-if="$vuetify.breakpoint.smAndUp">
          <td>{{ pVal(item, "nama") }}</td>
          <td>{{ pVal(item, "tgl_mulai") | toD }}</td>
          <td>{{ pVal(item, "tgl_selesai") | toD }}</td>
          <td>
            <m-menu
              v-if="isCan(`periode-laporan.${keyAkses}update`) ||
                        isCan(`periode-laporan.${keyAkses}destroy`)"
              left
              style="float:right"
              :items="more_menu"
              :object="item"
            />
          </td>
        </tr>
        <tr v-else>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[0].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, "nama") }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[1].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, "tgl_mulai") | toD }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[2].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, "tgl_selesai") | toD }}
            </div>
          </td>
          <td
            class="v-data-table__mobile-row"
            v-if="isCan('periode-laporan.store')"
          >
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[3].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              <m-menu
                left
                style="float:right"
                :items="more_menu"
                :object="item"
              />
            </div>
          </td>
        </tr>
      </template>
    </m-card-list>
    <ChangeDlg ref="dlg" />
  </v-container>
</template>

<script>
import {isCan} from "@/tools";
import ChangeDlg from "../components/Form.vue";
import BlockCard from "@/components/BlockCard";

export default {
  components: {
    ChangeDlg,
    BlockCard
  },
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Tanggal Awal", align: "left", value: "tgl_mulai" },
        { text: "Tanggal Akhir", align: "left", value: "tgl_akhir" },
        { text: "", align: "left", sortable: false }
      ],
      stat: {
        jenis_kelamin: { data: [], legend: [] },
        usia: { data: [], legend: [] }
      },
      more_menu: [
        {
          title: "Ubah",
          click: (i, o) => this.edit(o),
          check: () => isCan(`periode-laporan.${this.keyAkses}update`)
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o),
          check: () => isCan(`periode-laporan.${this.keyAkses}destroy`)
        }
      ]
    };
  },
  computed: {},
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("periode/get", {
          organisasi_id: this.organisasi_id || this.tenant_id,
          params: {
            page: this.cp,
            keyword: this.textSearch
          }
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
        </div>

        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.nama}<br>
        </div>

      `
      )
        .then(() =>
          this.$store.dispatch("periode/drop", {
            organisasi_id: this.organisasi_id || this.tenant_id,
            periode_laporan_id: item.periode_laporan_id
          })
        )
        .then(() => {
          this.$info("Data berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
